exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdl-checkbox {\n  cursor: pointer;\n}\n\n.mdl-checkbox .filter-title {\n  float: left;\n  padding-top: 2px;\n}\n\n.mdl-checkbox mdl-icon {\n  color: #666;\n}\n\n", ""]);

// exports
